const MEDIA_ITEMS = [
  {
    title: '犯罪都市4',
    desc: '马东锡主演的动作犯罪系列最新力作，怪物刑警马锡道再度出击，硬核打斗场面全面升级。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20style%20with%20dramatic%20Korean%20film%20aesthetic%2C%20intense%20urban%20crime%20scene%2C%20warm%20dramatic%20lighting%2C%20movie%20poster%20composition%2C%20dark%20moody%20tones%20with%20red%20accents&width=800&height=450&seq=media-01&orientation=landscape',
    tag: '动作犯罪',
  },
  {
    title: '你想活出怎样的人生',
    desc: '宫崎骏最新动画电影，讲述少年在奇幻世界中的成长冒险，画面唯美，情感深沉。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20film%20art%20style%20with%20dreamy%20fantasy%20landscape%2C%20Ghibli-inspired%20aesthetic%2C%20soft%20watercolor%20textures%2C%20warm%20golden%20light%2C%20ethereal%20atmosphere%2C%20hand-drawn%20animation%20style&width=800&height=450&seq=media-02&orientation=landscape',
    tag: '动画奇幻',
  },
  {
    title: '破墓',
    desc: '韩国现象级恐怖片，金高银、李到晛主演，融合风水玄学与神秘恐怖，年度必看。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20Korean%20horror%20film%20aesthetic%2C%20foggy%20graveyard%20scene%2C%20atmospheric%20tension%2C%20muted%20earthy%20tones%2C%20cinematic%20composition%2C%20subtle%20supernatural%20elements%2C%20film%20noir%20lighting&width=800&height=450&seq=media-03&orientation=landscape',
    tag: '恐怖悬疑',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">精彩预告</h2>
        <p className="text-sm text-foreground-500 mb-8">近期最受期待的日韩电影抢先看</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 text-[10px] px-2 py-1 rounded-full bg-background-50/90 text-foreground-700 font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}